/* Enhance native details inside the existing gallery; no cart, price or variant controller. */
(() => {
  const init = (scope = document) => scope.querySelectorAll('[data-package-photos]:not([data-ready])').forEach(root => {
    const buttons = [...root.querySelectorAll('[data-package-photo-choice]')];
    const panels = [...root.querySelectorAll('[data-package-photo-panel]')];
    if (!buttons.length || buttons.length !== panels.length) return;
    const choose = (index, announce = true) => {
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      panels.forEach((panel, i) => { panel.hidden = i !== index; panel.open = i === index; });
      if (announce) root.querySelector('[data-package-photo-status]').textContent = buttons[index].textContent.trim();
    };
    buttons.forEach((button, i) => button.addEventListener('click', () => choose(i)));
    choose(0, false);
    root.dataset.ready = 'true';
  });
  const start = () => {
    init();
    document.querySelectorAll('.j-product--package').forEach(root => {
      new MutationObserver(() => init(root)).observe(root, {childList: true, subtree: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
